<template>
  <div class="position-relative" id="dailychart">
    <div v-if="isError" class="error">{{ errorMsg }}</div>
    <div v-if="isLoading" style="padding: 40px; text-align: center;">
      <img :src="loadingUrl" style="vertical-align: middle"> Načítavam údaje...
    </div>

    <template v-if="isDataLoaded">

      <div class="dchart">
        <highcharts ref="chart" v-for="(chartOptions, index) in chartOptionAll"
                    :key="index + `-` + chartOptions.id"
                    :options="chartOptions"
                    :updateArgs="[true, true, true]"
        >
        </highcharts>
      </div>
      <div class="clearfix"></div>
      <div class="vydal">{{ vydal }}</div>


      <template v-if="selectedDay !== null">
        <template v-if="selectedDay.textova_predpoved?.is_extra_3_days === true">
          <h1>Predpoveď počasia pre Slovensko na {{ minMultiDay?.dt }} ({{ minMultiDay?.den }}) až {{ maxMultiDay?.dt }} ({{ maxMultiDay?.den }})</h1>
        </template>
        <template v-else>
          <h1>Predpoveď počasia pre Slovensko na {{ selectedDay.dt }} ({{ selectedDay.den }})</h1>
        </template>

        <template v-if="selectedDay.textova_predpoved.situacia">
          <h2>Situácia</h2>
          <p v-html="selectedDay.textova_predpoved.situacia"></p>
        </template>
        <template v-if="selectedDay.textova_predpoved.predpoved">
          <h2>Predpoveď</h2>
          <p v-html="selectedDay.textova_predpoved.predpoved"></p>
        </template>
        <template v-else>
          <em>Textová predpoveď pre vybraný deň nie je dostupná</em>
        </template>
        <template v-if="selectedDay.textova_predpoved.vydal">
          <small>{{ selectedDay.textova_predpoved.vydal }}</small>
        </template>

      </template>

    </template>

  </div>
</template>

<script>

import SHMUconf from '../../shmu_conf';
import Axios from "axios";
import myMixin from './mixin';
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import Accessibility from 'highcharts/modules/accessibility';
// import Export from 'highcharts/modules/exporting';
// import OfflineExporting from 'highcharts/modules/offline-exporting';
import HighchartsVue, {Chart} from 'highcharts-vue';
// import HighchartsCustomEvents from 'highcharts-custom-events'


HighchartsMore(Highcharts);
Accessibility(Highcharts);
// Export(Highcharts);
// OfflineExporting(Highcharts)
// HighchartsCustomEvents(Highcharts);

Highcharts.setOptions({
  lang: {
    weekdays: ['Nedeľa','Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    months: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December'],
    resetZoom: 'Zrušiť priblíženie'
  },
  global: {
    useUTC: true
  }
});


export default {
  components: {
    highcharts: Chart
  },
  mixins: [myMixin],
  name: 'DailyForecastComponent',
  data() {
    return {
      loadingUrl: SHMUconf.SITE_BASE_URL + 'img/loader.gif',
      isError: false,
      errorMsg: null,
      isDataLoaded: false,
      isChartLoading: false,
      isLoading: true,
      productData: null,
      selectedDay: null,
      chartOptions: {},
      chartOptions2: {},
      izo10Color: 'rgba(255,255,0,0.5)',
    }
  },
  watch: {
    productData(v) {
      this.updateIsChartLoading(true);
      this.prepareData();
    }

  },
  mounted() {

    this.getProductData();


  },
  computed: {
    chartOptionAll() {
      return [this.chartOptions, this.chartOptions2]
    },
    categories() {
      if (this.isDataLoaded) {
        return this.productData.reduce((acc, item) => {
          acc.push(item.den + '<br>' + item.dt);
          return acc;
        }, []);
      }

      return [];
    },
    teplotaNoc() {
      if (this.isDataLoaded) {
        return this.productData.reduce((acc, item) => {
          acc.push([item.t_min_noc, item.t_max_noc]);
          return acc;
        }, []);
      }

      return [];
    },
    teplotaDen() {
      if (this.isDataLoaded) {
        return this.productData.reduce((acc, item) => {
          acc.push([item.t_min_den, item.t_max_den]);
          return acc;
        }, []);
      }

      return [];
    },
    maxTeplota() {
      if (this.isDataLoaded) {
        let max_t = -999;
        this.productData.forEach((item, i) => {
          if (item.t_min_den > max_t) { max_t = item.t_min_den; }
          if (item.t_max_den > max_t) { max_t = item.t_max_den; }
          if (item.t_max_noc > max_t) { max_t = item.t_max_noc; }
          if (item.t_min_noc > max_t) { max_t = item.t_min_noc; }
        });

        return max_t;
      }
      return 40;
    },
    zrazkyNoc() {
      if (this.isDataLoaded) {
        return this.productData.reduce((acc, item) => {
          acc.push(item.zra_pokrytie_noc);
          return acc;
        }, []);
      }

      return [];
    },
    zrazkyDen() {
      if (this.isDataLoaded) {
        return this.productData.reduce((acc, item) => {
          acc.push(item.zra_pokrytie_den);
          return acc;
        }, []);
      }

      return [];
    },
    minMultiDay() {
      let res = this.productData.filter(item => item?.textova_predpoved?.is_extra_3_days === true);
      if (res.length) {
        let res2 = res.sort((a, b) => parseInt(a.dt_ts) - parseInt(b.dt_ts));
        return res2[0];
      }
      return null;
    },
    maxMultiDay() {
      let res = this.productData.filter(item => item?.textova_predpoved?.is_extra_3_days === true);
      if (res.length) {
        let res2 = res.sort((a, b) => parseInt(b.dt_ts) - parseInt(a.dt_ts));
        return res2[0];
      }
      return null;
    },
    vydal() {
      if (this.selectedDay) {
        return this.selectedDay.vydal;
      }
      let p = structuredClone(this.productData);
      let r = p.sort((a,b) => { return b.dt_ts - a.dt_ts; });
      if (r) {
        return r[0].vydal;
      }
      return '';


    }


  },
  methods: {

    getProductData() {
      const self = this;
      self.isDataLoaded = false;

      Axios.get(SHMUconf.API_BASE_URL + 'meteo/getdailyforecast', {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {
          self.productData = response.data
          self.isError = false;
          self.errorMsg = null;
          self.isDataLoaded = true;
        } else {
          this.isError = true;
          if (response.data.error[0].text) {
            this.errorMsg = response.data.error[0].text;
          } else {
            this.errorMsg = 'Nastala chyba pri načítavaní údajov!';
          }
        }
        this.isLoading = false;
      }).catch((error) => {
        this.isError = true;
        this.errorMsg = 'Nastala chyba pri komunikácii so serverom!';
        this.isLoading = false;
      });
    },

    drawWeatherSymbols(chart) {

      const self = this;

      chart.series[0].data.forEach((point, i) => {

        let data = self.productData.find (item => {
          return point.category === item.den + '<br>' + item.dt
        });

        let icon_n = null;
        let icon_d = null;
        let icon_n_text = null;
        let icon_d_text = null;
        if (data) {
          icon_n = data.icon_id_noc;
          icon_d = data.icon_id_den;
          icon_n_text = data.pocasie_noc;
          icon_d_text = data.pocasie_den;
        }

        if (icon_n !== null) {

          chart.renderer
              .image(
                  'https://www.shmu.sk' +
                  `/img/svg/ikony/v3/${icon_n}.svg`,
                  point.plotX + chart.plotLeft - 63,
                  74,
                  50,
                  41
              )
              .attr({
                zIndex: 5,
                title: icon_n_text
              })
              .on('click', function(el) {
                let e = chart.pointer.normalize(el);
                let day_index = Math.round(Math.abs(chart.xAxis[0].toValue(e.chartX)));  // xAxis je -0.5 az 0.5 pre jeden stlpec, takze ked ho zaokruhlime, mame index stlpca v grafe
                if (self.productData[day_index]) {
                  self.selectedDay = self.productData[day_index];
                }
              })
              .add();
        }

        if (icon_d !== null) {

          chart.renderer
              .image(
                  'https://www.shmu.sk' +
                  `/img/svg/ikony/v3/${icon_d}.svg`,
                  point.plotX + chart.plotLeft + 13,
                  74,
                  50,
                  41
              )
              .attr({
                zIndex: 5,
                title: icon_d_text
              })
              .on('click', function(el) {
                let e = chart.pointer.normalize(el);
                let day_index = Math.round(Math.abs(chart.xAxis[0].toValue(e.chartX)));  // xAxis je -0.5 az 0.5 pre jeden stlpec, takze ked ho zaokruhlime, mame index stlpca v grafe
                if (self.productData[day_index]) {
                  self.selectedDay = self.productData[day_index];
                }
              })
              .add();

        }


      });
    },

    drawBgLogo(chart, top) {
      const self = this;
      // console.log(chart);
      chart.renderer
          .image(
              'https://www.shmu.sk' +
              `/img/shmu_logo.svg`,
              chart.chartWidth / 2 - 250,
              top,
              500,
              354
          )
          .attr({
            zIndex: 0,
            opacity: 0.15
          })
          .add();

    },

    drawMidnightLines(chart, y, len) {

      const self = this;

      chart.series[0].data.forEach((point, i) => {

        chart.renderer
            .path(['M', point.plotX + chart.plotLeft, y, 'V', len])
            .attr({
              'stroke-width': 1,
              stroke: 'rgba(133,133,133,0.2)',
              zIndex: 5
            })
            .add();


      });
    },

    handleChartClick(el) {

      const self = this;

      if (el.point && el.point.category) {

        let data = self.productData.find (item => {
          return el.point.category === item.den + '<br>' + item.dt
        });

        if (data) {
          this.selectedDay = data
        } else {
          this.selectedDay = null;
        }
      } else {
        let chart = el.xAxis[0].axis.chart;
        let e = chart.pointer.normalize(el);
        let day_index = Math.round(Math.abs(chart.xAxis[0].toValue(e.chartX)));  // xAxis je -0.5 az 0.5 pre jeden stlpec, takze ked ho zaokruhlime, mame index stlpca v grafe
        if (self.productData[day_index]) {
          self.selectedDay = self.productData[day_index];
        }

      }
    },
    prepareData() {
      const self = this;

      if (this.productData) {
        this.chartOptions = {
          id: 'teplota',
          credits: {
            enabled: false
          },
          chart: {
            type: 'columnrange',
            inverted: false,
            margin: [120, 70, 15, 70],
            height: 400,
            animation: false,
            events: {
              render: (el) => {
                this.drawWeatherSymbols(el.target);
                this.drawMidnightLines(el.target, 70, 450);
                this.drawBgLogo(el.target, 70);
              },
              click: (el) => {
                this.handleChartClick(el)
              },
              load: (el) => {
                let chart = el.target;
                chart.xAxis[1].labelGroup.element.childNodes.forEach(function (label) {
                  label.style.cursor = "pointer";
                  label.onclick = function () {
                    let f = self.productData.find( item => {
                      // console.log(item.dt, e.srcElement.childNodes[2].nodeValue);
                      return item.dt === this.childNodes[2].nodeValue
                    });
                    if (f) {
                      self.selectedDay = f;
                    }

                  }
                });

              }
            }
          },
          exporting: {
            buttons: {
              contextButton: {
                menuItems: ['downloadPNG']
              }
            }
          },

          title: {
            text: ''
          },

          xAxis: [{
            categories: this.categories,
            gridLineColor: '#aaaaaa',
            gridLineWidth: 1,
            tickLength: 5,
            tickWidth: 1,
            tickColor: '#aaaaaa',
            lineColor: '#aaaaaa',
            lineWidth: 0,
            labels: {
              enabled: false,
              align: 'center',
              useHTML: false
            }
          },
            {
              // offset: 50,
              top: 70,
              categories: this.categories,
              linkedTo: 0,
              gridLineWidth: 1,
              gridLineColor: '#aaaaaa',
              tickLength: 50,
              tickWidth: 1,
              tickColor: '#aaaaaa',
              lineColor: '#aaaaaa',
              lineWidth: 1,
              opposite: true,
              labels: {
                enabled: true,
                align: 'center',
                useHTML: false,
                /*
                events: {
                  click: function(e) {
                    // console.log(e.srcElement.childNodes[2]);
                    let f = self.productData.find( item => {
                      // console.log(item.dt, e.srcElement.childNodes[2].nodeValue);
                      return item.dt === e.srcElement.childNodes[2].nodeValue
                    });
                    if (f) {
                      self.selectedDay = f;
                    }
                  }
                },
                 */

              },
            }
          ],

          yAxis: [{
            title: {
              text: 'Teplota (°C)'
            },
            plotLines:[
              { value: 0, color: self.izo10Color, width:2, zIndex:1},
              { value: 10, color: self.izo10Color, width:2, zIndex:1},
              { value: 20, color: self.izo10Color, width:2, zIndex:1},
              { value: 30, color: self.izo10Color, width:2, zIndex:1},
              { value: 40, color: self.izo10Color, width:2, zIndex:1},
              { value: 50, color: self.izo10Color, width:2, zIndex:1},
              { value: -10, color: self.izo10Color, width:2, zIndex:1},
              { value: -20, color: self.izo10Color, width:2, zIndex:1},
              { value: -30, color: self.izo10Color, width:2, zIndex:1},
              { value: -40, color: self.izo10Color, width:2, zIndex:1},
              { value: -50, color: self.izo10Color, width:2, zIndex:1},
            ], // ciara na 0
            plotBands: [{from: -10000, to: 0, color: 'rgba(0, 0, 255, 0.05)'}], // modre podfarbenie pri zapornych teplotach
            tickInterval: 1,
            minorTickInterval: 1,
            tickWidth: 1,
            gridLineWidth: 1,
            tickColor: '#aaaaaa',
            // max: this.maxTeplota + 6



          },
            {
              linkedTo:0,
              opposite: true,
              title: {
                text: 'Teplota (°C)'
              },
              tickWidth: 1,
              gridLineWidth: 1,
              tickColor: '#aaaaaa',
            }
          ],

          tooltip: {
            valueSuffix: '°C',
            pointFormatter: function() {
              // console.log(this);
              let start = this.high,
                  end = this.low,
                  ider = this.series.userOptions.id,
                  s_name = this.series.userOptions.name,
                  s_color = this.series.userOptions.color,
                  suffix = this.series.tooltipOptions.valueSuffix;

              if (ider === 'night') {
                return  `<strong style="color:${s_color}">● ${s_name}:</strong> <strong>${start}${suffix} / ${end}${suffix}</strong>`
              }
              return  `<strong style="color:${s_color}">● ${s_name}:</strong> <strong>${end}${suffix} / ${start}${suffix}</strong>`
            }
          },

          plotOptions: {
            series: {
              events: {
                click: function (e) {
                  self.handleChartClick(e)
                },
              },
              states: {
                inactive: {
                  opacity: 1
                }
              }
            },
            columnrange: {
              animation: false,
              borderRadius: 0,
              borderWidth: 0,
              centerInCategory: true,
              pointPadding: 0.25,
              groupPadding: 0,
              dataLabels: {
                enabled: true,
                format: '{y}°C'
              }
            },
          },

          legend: {
            enabled: false
          },

          series: [{
            id: 'night',
            name: 'V noci',
            color: '#0204a2',
            data: this.teplotaNoc,
          },{
            id: 'day',
            name: 'Cez deň',
            color: '#b60000',
            data: this.teplotaDen,
          }
          ]

        }

        // DRUHA CAST GRAFU

        this.chartOptions2 = {
          id: 'zrazky',
          credits: {
            enabled: false
          },
          chart: {
            animation: false,
            type: 'column',
            inverted: false,
            margin: [20, 70, 60, 70],
            height: 300,
            events: {
              render: (el) => {
                this.drawMidnightLines(el.target, 0, 240);
                this.drawBgLogo(el.target, -60);
              },
              click: (el) => {
                this.handleChartClick(el)
              },
              load: (el) => {
                let chart = el.target;
                chart.xAxis[0].labelGroup.element.childNodes.forEach(function (label) {
                  label.style.cursor = "pointer";
                  label.onclick = function () {
                    let f = self.productData.find( item => {
                      // console.log(item.dt, e.srcElement.childNodes[2].nodeValue);
                      return item.dt === this.childNodes[2].nodeValue
                    });
                    if (f) {
                      self.selectedDay = f;
                    }

                  }
                });

              }
            }

          },
          exporting: {
            buttons: {
              contextButton: {
                menuItems: ['downloadPNG']
              }
            }
          },
          title: {
            text: ''
          },


          xAxis: {
            categories: this.categories,
            gridLineColor: '#aaaaaa',
            gridLineWidth: 1,
            tickColor: '#aaaaaa',
            lineColor: '#aaaaaa',
            labels: {
              align: 'center',
              useHTML: false,
              /*
              events: {
                click: function(e) {
                  // console.log(e.srcElement.childNodes[2]);
                  let f = self.productData.find( item => {
                    // console.log(item.dt, e.srcElement.childNodes[2].nodeValue);
                    return item.dt === e.srcElement.childNodes[2].nodeValue
                  });
                  if (f) {
                    self.selectedDay = f;
                  }
                }
              },
               */
            },
            tickLength: 50,
            tickWidth: 1,
          },

          yAxis: [{
            title: {
              text: 'Pokrytie územia SR zrážkami (%)',
              margin:0
            },
            min:0,
            max:100,
            minorTickInterval: 5,
            tickWidth: 1,  gridLineWidth: 1,
            tickColor: '#aaaaaa',



          },
            {
              linkedTo:0,
              opposite: true,
              title: {
                text: 'Pokrytie územia SR zrážkami (%)',
                margin:0
              },
              tickWidth: 1,  gridLineWidth: 1,
              tickColor: '#aaaaaa',
            }
          ],

          tooltip: {
            valueSuffix: '%'
          },

          plotOptions: {
            series: {
              events: {
                click: function (e) {
                  self.handleChartClick(e)
                },
              },
              states: {
                inactive: {
                  opacity: 1
                }
              }
            },
            column: {
              animation: false,
              borderRadius: 0,
              borderWidth: 0,
              pointPadding: 0.25,
              groupPadding: 0,
              centerInCategory: true,
              dataLabels: {
                enabled: true,
                format: '{y}%'
              }
            }
          },

          legend: {
            enabled: false
          },

          series: [{
            id: 'night',
            name: 'V noci',
            color: 'rgb(131,131,131)',
            data: this.zrazkyNoc,
          },{
            id: 'day',
            name: 'Cez deň',
            color: 'rgb(131,131,131)',
            data: this.zrazkyDen,
          }]

        }
      }
    },

    updateIsChartLoading(state) {
      this.isChartLoading = state;
    },


  },
  beforeDestroy() {

  }
}
</script>

<style>

#dailychart {
  width: 100%;
  min-height: 200px;
}

#dailychart ul li:before {
  border-style: none !important;
}

.vydal {
  margin-left: 20px;
  color: #444;
}


</style>
